import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CREDIT_PORTAL_URL, PATH } from 'shared';
import { pushEdsCFEPagesVisited, setEdsCFEPagesVisited } from '../../slice';
function useEDSPreventBacktracking({ currentPage }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const edsLocationId = useSelector((state) => state.root.creditPortal.eds.edsLocationId);
    const edsCFEPagesVisited = useSelector((state) => state.root.creditPortal.eds.edsCFEPagesVisited);
    useEffect(() => {
        if (edsCFEPagesVisited.includes(currentPage)) {
            dispatch(setEdsCFEPagesVisited([]));
            history.push(edsLocationId
                ? `${CREDIT_PORTAL_URL + PATH.EDS.BASE + PATH.EDS.INDEX}?locationId=${edsLocationId}`
                : CREDIT_PORTAL_URL);
        }
        else {
            dispatch(pushEdsCFEPagesVisited(currentPage));
        }
    }, []);
    return {
        edsCFEPagesVisited,
    };
}
export default useEDSPreventBacktracking;
